import React from "react";

// components
import CreateCompany from "../misc/CreateCompany";
import Button from "../../../component/element/forms/Button";
// constants and icon
import { FaPlus, FaStar } from "react-icons/fa6";
import { VscFolderActive } from "react-icons/vsc";

// state
import { useNavigate } from "react-router-dom";
import {
  company_status,
  delete_company,
  get_companies,
  premium_status,
} from "../../../services/apis/company";
import { useAppDispatch, useAppSelector } from "../../../store";
import { ICompany } from "../../../store/types/company";
// import Paginate from "../../../component/ui/paginate";
import { ColumnDef } from "@tanstack/react-table";
import DataTable from "../../../component/element/table";
import ItemAction from "../../../component/ui/action/ItemAction";
import { Mail } from "lucide-react";
import EmailNotification from "../misc/EmailNotification";
// import { SpaceContext } from "antd/lib/space";

const Company: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const companies = useAppSelector(({ company }) => company.companies);
  const last_page = useAppSelector(({ company }) => company.last_page);
  const current_page = useAppSelector(({ company }) => company.current_page);
  const loadingCompanyId = useAppSelector(({ company }) => company.loadingCompanyId);

  const [create, createSet] = React.useState<boolean>(false);
  const [modalOpen, setModalOpen] = React.useState<boolean>(false);

  const onLoad = React.useCallback(() => {
    get_companies(dispatch, current_page);
  }, [current_page, dispatch]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  const columns: ColumnDef<ICompany>[] = [
    {
      accessorKey: "company_name",
      header: "Name",
      cell: ({ getValue }) => (
        <span className="capitalize">{getValue() as string}</span>
      ),
    },
    { accessorKey: "company_email", header: "Email" },
    {
      accessorKey: "rc_number",
      header: "RC Number",
      cell: ({ getValue }) => (
        <span className="uppercase">{getValue() as string}</span>
      ),
    },
    {
      accessorKey: "status",
      header: "Active",
      cell: ({ getValue, row }) => {
        const status = getValue() as string;
        const data = row.original;
        return (
          <VscFolderActive
            color={status === "0" ? "red" : "green"}
            size={25}
            onClick={() => company_status(data.id, dispatch)}
            className="cursor-pointer"
          />
        );
      },
    },
    {
      accessorKey: "premium_status",
      header: "Premium",
      cell: ({ getValue, row }) => {
        const status = getValue() as string;
        const data = row.original;
        return (
          <FaStar
            color={status === "0" ? "" : "#FFD700"}
            size={22}
            onClick={() => premium_status(data.id, dispatch)}
            className="cursor-pointer"
          />
        );
      },
    },
    {
      accessorKey: "id",
      header: "Action",
      cell: ({ getValue }) => {
        const id = getValue() as string;
        return (
          <ItemAction
            show_edit={false}
            onView={() => navigate(`/companies/${id}/details`)}
            onEdit={() => null}
            onDelete={() => delete_company(id, dispatch)}
            delete_loading={loadingCompanyId === id}
          />
        );
      },
    },
  ];

  return (
    <div className="">
      <div className="w-full flex justify-between items-center">
        <h2 className="font-bold text-xl capitalize mb-0">Company</h2>
        <div className="flex items-center gap-2">
          <Button
            title="Post Notification"
            children={<Mail className="mr-2" />}
            onClick={() => setModalOpen(true)}
            className="px-3"
          />
          <Button
            title="Create"
            children={<FaPlus className="mr-2" />}
            onClick={() => createSet(true)}
            className="px-3"
          />
        </div>
      </div>

      <div className="mt-4">
        <DataTable columns={columns} data={companies} current_page={current_page}
          last_page={last_page}
          onNext={(page) => get_companies(dispatch, page)}
          onPrev={(page) => get_companies(dispatch, page)} />

      </div>

      <EmailNotification
        isOpen={modalOpen}
        isClose={() => setModalOpen(false)}
      />

      <CreateCompany visible={create} onHandler={() => createSet(false)} />
    </div>
  );
};

export default Company;
